import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NotificationInterface } from './notification.interface';

@Component({
  selector: 'gtd-notification-description',
  template: `<div class="c-notification-desc" [innerHTML]="htmlMessage" [class.-short]="short" [ngClass]="customClass"></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationDescriptionComponent implements OnInit, AfterViewInit {
  @Input() data: NotificationInterface;
  @Input() short = true;
  @Input() customClass: string;
  public htmlMessage: string;

  ngOnInit(): void {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const msg = this.data.message;
    this.htmlMessage = msg?.replace(urlRegex, (url: string) => {
      return '<a href="' + url + '" target="_blank" class="c-link c-link--primary -blue -notification-link">' + url + '</a>';
    });
    const jsonUrlRegex = /(\{(?:\[??[^[]*?\}))/g;
    if (jsonUrlRegex.test(msg)) {
      this.htmlMessage = msg.replace(jsonUrlRegex, (json: string) => {
        try {
          const data: { url: string; label: string } = JSON.parse(json);
          return (
            '<a href="' + data.url + '" target="_blank" class="c-link c-link--primary -blue -notification-link">' + data.label + '</a>'
          );
        } catch {
          return json;
        }
      });
    }
  }

  ngAfterViewInit(): void {
    for (const elem of Array.from(document.getElementsByClassName('-notification-link'))) {
      elem.addEventListener('click', (event: Event) => event.stopPropagation());
    }
  }
}
